export const GET_DROPDOWN = 'EQUITY: GET_DROPDOWN';
export const GET_DROPDOWN_SUCCESS = 'EQUITY: GET_DROPDOWN_SUCCESS';
export const GET_DROPDOWN_FAILURE = 'EQUITY: GET_DROPDOWN_FAILURE';
export const GET_PRODUCTS = 'EQUITYPRODUCTS:GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'EQUITYPRODUCTS:GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'EQUITYPRODUCTS:GET_PRODUCTS_FAILURE';
export const GET_PRODUCTS_BULK = 'EQUITYPRODUCTS:GET_PRODUCTS_BULK';
export const GET_PRODUCTS_BULK_SUCCESS =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_SUCCESS';
export const GET_PRODUCTS_BULK_FAILURE =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_FAILURE';
export const SET_PRODUCTS = 'EQUITYPRODUCTS:SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'EQUITYPRODUCTS:CLEAR_PRODUCTS';
export const VALIDATE_PRODUCTS = 'EQUITYPRODUCTS:VALIDATE_PRODUCTS';
export const VALIDATE_PRODUCTS_SUCCESS =
    'EQUITYPRODUCTS:VALIDATE_PRODUCTS_SUCCESS';
export const VALIDATE_PRODUCTS_FAILURE =
    'EQUITYPRODUCTS: VALIDATE_PRODUCTS_FAILURE';
export const CLEAR_VALIDATED_PRODUCTS =
    'EQUITYPRODUCTS: CLEAR_VALIDATED_PRODUCTS';
export const SET_PROGRESS_BAR_STATUS =
    'EQUITYPROGRESSBAR: SET_PROGRESS_BAR_STATUS';
export const RESET_PROGRESS_BAR_STATUS =
    'EQUITYPROGRESSBAR: RESET_PROGRESS_BAR_STATUS';
export const SET_PROGRESS_BAR_CURRENT_STEP =
    'EQUITYPROGRESSBAR: SET_PROGRESS_BAR_CURRENT_STEP';
export const SET_PROGRESS_BAR_EDIT_MODE =
    'EQUITYPROGRESSBAR: SET_PROGRESS_BAR_EDIT_MODE';
//product details

export const GET_PRODUCT_DETAILS = 'EQUITYPRODUCTS: GET_PRODUCT_DETAILS';
export const GET_PRODUCT_DETAILS_SUCCESS =
    'EQUITYPRODUCTS: GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_ERROR =
    'EQUITYPRODUCTS: GET_PRODUCT_DETAILS_ERROR';
export const SORT_PRODUCT_DETAILS = 'EQUITYPRODUCTS: SORT_PRODUCT_DETAILS';

export const GET_EQUITY_DETAILS = 'EQUITY: GET_EQUITY_DETAILS';
export const GET_EQUITY_DETAILS_SUCCESS = 'EQUITY: GET_EQUITY_DETAILS_SUCCESS';
export const GET_EQUITY_DETAILS_FAILURE = 'EQUITY: GET_EQUITY_DETAILS_FAILURE';
export const SAVE_EQUITY_DETAILS = 'EQUITY: SAVE_EQUITY_DETAILS';
export const SAVE_EQUITY_DETAILS_SUCCESS =
    'EQUITY: SAVE_EQUITY_DETAILS_SUCCESS';
export const SAVE_EQUITY_DETAILS_FAILURE =
    'EQUITY: SAVE_EQUITY_DETAILS_FAILURE';
export const UPDATE_EQUITY_DETAILS = 'EQUITY: UPDATE_EQUITY_DETAILS';
export const UPDATE_EQUITY_DETAILS_SUCCESS =
    'EQUITY: UPDATE_EQUITY_DETAILS_SUCCESS';
export const UPDATE_EQUITY_DETAILS_FAILURE =
    'EQUITY: UPDATE_EQUITY_DETAILS_FAILURE';
export const VALIDATE_ACCOUNT = 'EQUITY: VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS = 'EQUITY: VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNT_FAILURE = 'EQUITY: VALIDATE_ACCOUNT_FAILURE';

export const SET_PRODUCTSGUIDE = 'EQUITYPRODUCTSGUIDE:SET_PRODUCTSGUIDE';

export const GET_PRODUCTSGUIDE = 'EQUITYPRODUCTSGUIDE:GET_PRODUCTSGUIDE';
export const GET_PRODUCTSGUIDE_SUCCESS =
    'EQUITYPRODUCTSGUIDE:GET_PRODUCTSGUIDE_SUCCESS';
export const GET_PRODUCTSGUIDE_FAILURE =
    'EQUITYPRODUCTSGUIDE:GET_PRODUCTSGUIDE_FAILURE';

//category data
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA =
    'EQUITYPRODUCTS:GET_PRODUCT_BRAND_AND_CATEGORY_DATA';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS =
    'EQUITYPRODUCTS:GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE =
    'EQUITYPRODUCTS:GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE';

//approach and technology
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY =
    'EQUITYPRODUCTS:GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS =
    'EQUITYPRODUCTS:GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE =
    'EQUITYPRODUCTS:GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE';

export const CLEAR_PRODUCTS_GUIDE = 'EQUITYPRODUCTSGUIDE:CLEAR_PRODUCTS_GUIDE';
export const UPDATE_CART_DATA = 'EQUITY: UPDATE_CART_QUANTITY';
export const UPDATE_CART_PRODUCTS_QUANTITY =
    'EQUITY: UPDATE_CART_PRODUCTS_QUANTITY';
export const CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT =
    'EQUITY:CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT';
export const SET_CART_DATA = 'EQUITY: SET_CART_DATA';
export const SET_CART_DATA_PRICE_OVERRIDE =
    'EQUITY: SET_CART_DATA_PRICE_OVERRIDE';
export const UPDATE_CART_DATA_PRICEOVERRIDE =
    'EQUITY: UPDATE_CART_DATA_PRICEOVERRIDE';
//Product Templates

export const SET_EXPANDED_FILTER_VIEW = 'EQUITY: SET_EXPANDED_FILTER_VIEW';
export const SET_PRODUCTSTEMPLATESFILTER =
    'EQUITYPRODUCTSTEMPLATESFILTER:SET_PRODUCTSTEMPLATESFILTER';

export const GET_PRODUCTSTEMPLATESFILTER =
    'EQUITYPRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER';
export const GET_PRODUCTSTEMPLATESFILTER_SUCCESS =
    'EQUITYPRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_SUCCESS';
export const GET_PRODUCTSTEMPLATESFILTER_FAILURE =
    'EQUITYPRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_FAILURE';

//Update Template filter refine data (listing)
export const SET_PRODUCT_TEMPLATE_REFINE_DATA =
    'EQUITY: SET_PRODUCT_TEMPLATE_REFINE_DATA';
export const SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST =
    'EQUITY: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST';

//get detailed templates list
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST =
    'EQUITY: GET_DETAILED_PRODUCT_TEMPLATE_LIST';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS =
    'EQUITY: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE =
    'EQUITY: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE';

//create template
export const CREATE_PRODUCT_TEMPLATE = 'EQUITY: CREATE_PRODUCT_TEMPLATE';
export const CREATE_PRODUCT_TEMPLATE_SUCCESS =
    'EQUITY: CREATE_PRODUCT_TEMPLATE_SUCCESS';
export const CREATE_PRODUCT_TEMPLATE_FAILURE =
    'EQUITY: CREATE_PRODUCT_TEMPLATE_FAILURE';

export const RESET_CREATE_TEMPLATE = 'EQUITY: RESET_CREATE_TEMPLATE';

//update product template
export const UPDATE_PRODUCT_TEMPLATE = 'EQUITY: UPDATE_PRODUCT_TEMPLATE';
export const UPDATE_PRODUCT_TEMPLATE_SUCCESS =
    'EQUITY: UPDATE_PRODUCT_TEMPLATE_SUCCESS';
export const UPDATE_PRODUCT_TEMPLATE_FAILURE =
    'EQUITY: UPDATE_PRODUCT_TEMPLATE_FAILURE';

//get template details with template id
export const GET_TEMPLATE_DETAILS = 'EQUITY: GET_TEMPLATE_DETAILS';
export const GET_TEMPLATE_DETAILS_SUCCESS =
    'EQUITY: GET_TEMPLATE_DETAILS_SUCCESS';
export const GET_TEMPLATE_DETAILS_FAILURE =
    'EQUITY: GET_TEMPLATE_DETAILS_FAILURE';

export const GET_DATA_FOR_PRODUCT_TEMPLATE =
    'EQUITY: GET_DATA_FOR_PRODUCT_TEMPLATE';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS =
    'EQUITY: GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE =
    'EQUITY: GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE';
export const UPDATE_PRODUCT_TEMPLATE_LIST =
    'EQUITY: UPDATE_PRODUCT_TEMPLATE_LIST';

export const STORE_EQUITY_DETAILS = 'EQUITY: STORE_EQUITY_DETAILS';
export const RESOURCE_TYPE = 'ZOR';
export const RESET_CART_DATA = 'EQUITY: RESET_CART_DATA';
export const GET_PRODUCTS_PRICE = 'EQUITY: GET_PRODUCTS_PRICE';
export const GET_PRICES_FOR_ITEMS = 'EQUITY: GET_PRICES_FOR_ITEMS';
export const GET_PRICES_FOR_ITEMS_SUCCESS =
    'EQUITY: GET_PRICES_FOR_ITEMS_SUCCESS';
export const GET_PRICES_FOR_ITEMS_FAILURE =
    'EQUITY: GET_PRICES_FOR_ITEMS_FAILURE';
export const SET_PRICES_FOR_ITEMS = 'EQUITY:SET_PRICES_FOR_ITEMS';
export const SET_CART_LODER = 'EQUITY:SET_CART_LODER';
export const STORE_ITEM_TABLE_DATA = 'EQUITY: STORE_ITEM_TABLE_DATA';
export const STORE_ITEM_TABLE_DATA_SUCCESS =
    'EQUITY: STORE_ITEM_TABLE_DATA_SUCCESS';
export const STORE_ITEM_TABLE_DATA_FALURE =
    'EQUITY: STORE_ITEM_TABLE_DATA_FAILURE';

// add po image
export const EQUITY_USAGE_ATTACHMENT_UPLOAD = 'EQUITY: USAGE_ATTACHMENT_UPLOAD';
export const EQUITY_USAGE_ATTACHMENT_UPLOAD_FAILURE =
    'EQUITY: USAGE_ATTACHMENT_UPLOAD_FAILURE';
export const EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE =
    'EQUITY: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE';
export const EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE =
    'EQUITY: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE';
export const EQUITY_DELETE_ATTACHMENT_REQUEST =
    'EQUITY: DELETE_ATTACHMENT_REQUEST';
export const EQUITY_DELETE_ATTACHMENT_REQUEST_SUCCESS =
    'EQUITY: DELETE_ATTACHMENT_REQUEST_SUCCESS';
export const EQUITY_DELETE_ATTACHMENT_REQUEST_FAILURE =
    'EQUITY: DELETE_ATTACHMENT_REQUEST_FAILURE';
export const EQUITY_RESET_PO_ATTACHMENT = 'EQUITY: RESET_PO_ATTACHMENT';
export const EQUITY_GET_IMAGE_PO_PREVIEW = 'EQUITY: GET_IMAGE_PO_PREVIEW';
export const EQUITY_GET_IMAGE_PO_PREVIEW_SUCCESS =
    'EQUITY: GET_IMAGE_PO_PREVIEW_SUCCESS';
export const EQUITY_GET_IMAGE_PO_PREVIEW_FAILURE =
    'EQUITY: GET_IMAGE_PO_PREVIEW_FAILURE';
export const STORE_EQUITY_REFERENCE = 'EQUITY: STORE_EQUITY_REFERENCE';
export const RESET_PRICES_FOR_ITEMS = 'EQUITY: RESET_PRICES_FOR_ITEMS';
export const RESET_EQUITY_REFERENCE = 'EQUITY: RESET_EQUITY_REFERENCE';
export const INITIAL_EQUITY_DATA = 'EQUITY: INITIAL_EQUITY_DATA';
export const SET_ORDER_FROM_REPORT_USAGE =
    'EQUITY: SET_ORDER_FROM_REPORT_USAGE';
export const EQUITY_ORDER_FROM_USAGE_DETAILS =
    'EQUITY_ORDER_FROM_USAGE_DETAILS';

export const GET_DROPDOWN_OPTIONS = 'EQUITY: GET_DROPDOWN_OPTIONS';
export const GET_DROPDOWN_OPTIONS_SUCCESS =
    'EQUITY: GET_DROPDOWN_OPTIONS_SUCCESS';
export const GET_DROPDOWN_OPTIONS_FAILURE =
    'EQUITY: GET_DROPDOWN_OPTIONS_FAILURE';
export const SET_EQUITY_CU_IN_PROGRESS = 'EQUITY:SET_EQUITY_CU_IN_PROGRESS';

export const SET_EQUITY_ORDER_SUBMITTED = 'EQUITY: SET_EQUITY_ORDER_SUBMITTED';
export const RESET_CREATE_EQUITY = 'EQUITY: RESET_CREATE_EQUITY';
export const RESET_DERIVED_TERRITORIES = 'EQUITY: RESET_DERIVED_TERRITORIES';
export const STORE_SELECTED_PRODUCTS_DATA =
    'EQUITY: STORE_SELECTED_PRODUCTS_DATA';
export const RESET_STORE_ITEM_TABLE_DATA =
    'EQUITY: RESET_STORE_ITEM_TABLE_DATA';

export const SET_PRODUCT_TEMPLATE_UID = 'EQUITY: SET_PRODUCT_TEMPLATE_UID';

export const GET_PRODUCT_BUNDLE = 'EQUITY: GET_PRODUCT_BUNDLE';
export const GET_PRODUCT_BUNDLE_SUCCESS = 'EQUITY: GET_PRODUCT_BUNDLE_SUCCESS';
export const GET_PRODUCT_BUNDLE_FAILURE = 'EQUITY: GET_PRODUCT_BUNDLE_FAILURE';
export const CLEAR_TEMPLATE_PRODUCTS = 'SURGERY: CLEAR_TEMPLATE_PRODUCTS';
